

















































import {Component, Mixins} from 'vue-property-decorator';
import {
  CaseMeddra,
  CaseMeddraListInfo,
  CaseMeddraRetrieveResponse, CodesRetrieveResponse,
  CommonModelUtils,
  MeddraSelectDialogRequest,
} from '@/model/CommonModel';
import CommonPaginatedTable from '@/components/table/CommonPaginatedTable.vue';
import CommonPromptDialog from '@/components/dialog/CommonPromptDialog.vue';
import CommonButton from '@/components/button/CommonButton.vue';
import IconButton from '@/components/button/IconButton.vue';
import DefaultPaginateMixin from '@/views/DefaultPaginateMixin';
import DialogEventsMixin from '@/components/dialog/DialogEventsMixin';
import TextInput from '@/components/input/TextInput.vue';
import SelectDialogMixin from '@/components/dialog/SelectDialogMixin';
import CaseApi from '@/api/CaseApi';
import AiCodingDialogMixin from '@/components/dialog/AiCodingDialogMixin';
import AiCodingApi from '@/api/AiCodingApi';

@Component({
             components: {TextInput, CommonPromptDialog, CommonPaginatedTable, CommonButton, IconButton},
             mixins: [DefaultPaginateMixin, DialogEventsMixin, SelectDialogMixin, AiCodingDialogMixin]
           })
export default class CaseMeddraSelectDialog extends Mixins(DefaultPaginateMixin, DialogEventsMixin,
                                                            SelectDialogMixin, AiCodingDialogMixin) {
  private version: string = '';
  private searchLanguage: string = '';
  private values: CaseMeddraListInfo[] = [];
  private onSelect: (row: CaseMeddra) => void;
  private onCancel: (keyword: string) => void;
  private errMsg: string = '';
  private isAiRecommendation: boolean = false;

  get isLoading() {
    return this.loading;
  }

  get getValues() {
    return this.values;
  }

  get getAlert() {
    return this.errMsg;
  }

  get isJapanese() {
    return this.searchLanguage === 'Japanese';
  }

  get getColumns() {
    return [
      {
        columnId: 'lltName',
        columnLabel: this.$root.$t('message.case.meddra.lltName').toString(),
        filtered: 'N',
        visible: 'Y'
      },
      {
        columnId: 'ptName',
        columnLabel: this.$root.$t('message.case.meddra.ptName').toString(),
        filtered: 'N',
        visible: 'Y'
      },
      {
        columnId: 'socName',
        columnLabel: this.$root.$t('message.case.meddra.socName').toString(),
        filtered: 'N',
        visible: 'Y'
      },
      {
        columnId: 'synoName',
        columnLabel: this.$root.$t('message.case.meddra.synoName').toString(),
        filtered: 'N',
        visible: this.isJapanese ? 'Y' : 'N'
      },
      {
        columnId: 'imeFlag',
        columnLabel: this.$root.$t('message.case.meddra.ime').toString(),
        filtered: 'N',
        visible: 'Y'
      }
    ];
  }

  public mounted() {
    this.$modal
        .getEventBus()
        .$on('meddraSelectDialog', (params: MeddraSelectDialogRequest) => {
          this.show(params);
        });

    this.$modal.getEventBus().$on('hideMeddraSelectDialog', () => this.close());
  }

  public show(request: MeddraSelectDialogRequest) {
    this.width = request.width ? request.width : '1080px';
    this.version = request.version;
    this.searchLanguage = request.searchLanguage;
    this.onSelect = request.onSelect;
    this.onCancel = request.onCancel;
    this.keyword = request.keyword;
    this.isAiRecommendation = false;
    this.loading = false;

    if (request.isAiCoding) {
      this.isAiRecommendation = true;
      this.lastKeyword = '';
      this.retrieveRecommendedMeddraCodes(false)
          .then(() => {
            this.retrieveInitApis(request);
          });
    } else {
      this.retrieveInitApis(request);
    }

  }

  public retrieveInitApis(request: MeddraSelectDialogRequest) {
    this.visible = true;

    const shouldCallApis: Array<Promise<any>> = [];

    if (request.isAiCoding && this.values.length === 0) {
      shouldCallApis.push(this.retrieveRecommendedMeddraCodes(true));
    } else if (this.keyword.length > 0 ) {
      shouldCallApis.push(this.retrieve(1, 10));
    }

    this.loading = true;
    Promise.all(shouldCallApis)
        .finally(() => this.loading = false);
  }

  private retrieveRecommendedMeddraCodes(shouldUsePooling: boolean) {
    const params = {
      dicVersion: this.version,
      shouldUsePooling
    };
    const caseKey = Number(this.$route.params.caseKey);
    const rowNo = Number(this.$route.params.rowNo);

    return AiCodingApi.retrieveRecommendedMeddraCodes(caseKey, rowNo, params)
        .then((res: CaseMeddraRetrieveResponse) => {
          return this.handleRetrieveRecommendCodesSuccess(
              res,
              data => this.values = data.recommendedCodes,
              this.close
          );
        })
        .catch(({errMsg, errCode}) => {
          return this.handleRetrieveRecommendCodesError(errMsg, errCode, this.close, this.afterRequestFail);
        });

  }

  protected onSearch() {
    if (!this.keyword) {
      this.values = [];
      return;
    }
    this.isAiRecommendation = false;

    this.retrieve(1, 10);
  }

  public onRowClick(data: any) {
    const {row, $event} = data;

    if (this.onSelect) {
      this.onSelect(row);
    }

    this.close();
  }

  protected retrieve(pageNo: number, rowCount: number) {
    this.keyword = this.keyword.trim();

    this.errMsg = '';
    this.lastKeyword = this.keyword;

    if (!this.keyword) {
      this.values = [];
      return Promise.resolve();
    }

    if (this.keyword?.length < 2) {
      this.errMsg = this.$t('message.case.dialog.directInputMinLength').toString();
      this.values = [];
      return Promise.resolve();
    }

    const params: any = {pageNo, rowCount, keyword: this.keyword};
    this.loading = true;
    return CaseApi.retrieveMeddraCodes(this.version, params)
                  .then((res: CaseMeddraRetrieveResponse) => {
                    if (!res.success) {
                      return Promise.reject(res.errMsg);
                    }

                    const paginate = CommonModelUtils.getOrDefaultPaginate(res.data);
                    this.values = paginate.listInfo;
                    this.pageInfo = paginate.pageInfo;
                  })
                  .catch((errMsg) => this.afterRequestFail(errMsg))
                  .finally(() => this.loading = false);
  }

  public close() {
    if (this.onCancel) {
      this.onCancel(this.lastKeyword);
    }

    this.visible = false;
  }

  public afterClosed() {
    this.values = [];
    this.keyword = '';
    this.loading = false;
  }

  public destroyed() {
    this.$modal.getEventBus().$off('meddraSelectDialog');
    this.$modal.getEventBus().$off('hideMeddraSelectDialog');
  }
}
